import {InputZip} from '@vw-marketing/us-components';
import React, {useEffect} from 'react';
import {useFeatureServices} from '../../hooks/use-feature-services';
import {useZipData} from '../../hooks/use-zip-data';
import {VALIDATE_ZIP} from '../../store/queries/zip';

import {StyledFilterZipContainer} from './styles';
interface FilterZipProps {}

const FilterZip: React.FC<FilterZipProps> = () => {
  const {'zip-manager': zipManager} = useFeatureServices();

  useEffect(() => {
    // Access the div with class "location-text"
    const locationTextDiv = document.querySelector('.location-text');
    if (locationTextDiv) {
      locationTextDiv.classList.add('notranslate');
    }
  }, []);

  return (
    <StyledFilterZipContainer className="filter-zip_container">
      <InputZip
        zipManager={zipManager}
        validateZipQuery={VALIDATE_ZIP}
        useZipData={useZipData}
      />
    </StyledFilterZipContainer>
  );
};

export default FilterZip;
